module.exports = __webpack_public_path__ + "images/category_lp/art_work/store_images/2_a4cce7fc3049a50983e1d232cb189a50.png";